import React from "react";

const BackspaceRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.99995 6.2L8.79995 8M8.79995 8L10.5999 9.8M8.79995 8L10.5999 6.2M8.79995 8L6.99995 9.8M2.19995 8L4.92795 12.2624C5.07269 12.4886 5.27203 12.6747 5.50761 12.8036C5.74319 12.9325 6.00742 13.0001 6.27595 13H12.2C12.6243 13 13.0313 12.8314 13.3313 12.5314C13.6314 12.2313 13.7999 11.8243 13.7999 11.4V4.6C13.7999 4.17565 13.6314 3.76869 13.3313 3.46863C13.0313 3.16857 12.6243 3 12.2 3H6.27595C6.00742 2.99995 5.74319 3.06748 5.50761 3.19639C5.27203 3.32529 5.07269 3.51141 4.92795 3.7376L2.19995 8Z",
  stroke: "currentColor",
  strokeOpacity: 0.5,
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(BackspaceRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;